<template>
  <v-container fluid>
    <v-card outlined :loading="settingsLoading" :disabled="settingsLoading">
      <v-container>
        <v-card-title class="justify-center">{{ $t("return.searchOrder") }}</v-card-title>
        <span v-if="!settingsLoading">
          <v-card-text>{{ $t("return.textForSearchingAnOrder") }}</v-card-text>
          <search-order-form @confirm="list" :loadingData="loadingData"/>
        </span>

      </v-container>
      <v-data-table
        :headers="headers"
        :items="orders"
        :loading="loadingData"
        :loading-text="$t('return.ordersLoading')"
        :no-data-text="$t('return.noReturnableOrder')"
        mobile-breakpoint="768"
        v-show="!newInstance"
        hide-default-footer
        :options.sync="options"
        :header-props='headerProps'
      >
      <template v-slot:item.date="{ item }">
        <span>{{new Date(item.date)| moment("DD/MM/YYYY HH:mm:ss")}}</span>
      </template>
      <template v-slot:item.current_status="{ item }">
        <span>{{getStatusTranslation(item.current_status)}}</span>
      </template>
      <template v-slot:item.customer="{ item }">
        <span>{{ item.customer.last_name }} {{ item.customer.first_name }}</span>
      </template>
      <template v-slot:item.quantity="{ item }">
        <span>{{ getNbProducts(item) }}</span>
      </template>
      <template v-slot:item.total_price="{ item }">
        <span>{{ item.total_price | formatPrice(item.currency)}} {{item.currency ? item.currency.code : item.currency_code }}</span>
      </template>
        <template v-slot:item.oms_order="{ item }">
          <v-icon
          >
            {{ item.oms_order === false ?  'mdi-close' : 'mdi-check'}}
          </v-icon>
        </template>
      <template v-slot:item.action="{ item }">
          <span>
            <v-btn v-if="item.type == 'click_and_reserve'" text disabled :class="[$vuetify.breakpoint.width >= 768? '': 'pr-0']">
              {{ $t("return.notAuthorized") }}
            </v-btn>
            <v-btn v-else-if="!orderHasReturnableProducts(item)" text disabled :class="[$vuetify.breakpoint.width >= 768? '': 'pr-0']">
              {{ $t("return.noReturnableProduct") }}
            </v-btn>
            <v-btn v-else-if="allReturnableProductsAreFullyReturned(item)" text disabled :class="[$vuetify.breakpoint.width >= 768? '': 'pr-0']">
              {{ $t("return.productsAlreadyReturned") }}
            </v-btn>
            <v-btn
            v-else text color="primary" @click="createReturn(item.order_id)" :class="[$vuetify.breakpoint.width >= 768? '': 'pr-0']">
              {{ $t("return.createReturn") }}
            </v-btn>
          </span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {EventBus} from "../../event-bus";
import {mapState} from 'vuex';
import SearchOrderForm from "@/components/orders/SearchOrderForm.vue";
import { ReturnSettingsService } from '@/services/returnSettingsService.js'

export default {
  name: "ReturnSearchOrder",
  components: {
    SearchOrderForm,

  },
  data() {
    return {
      orders: [],
      loadingData: false,
      orderDetailsNotLoaded: false,
      options: {
        itemsPerPage: 15
      },
      totalOrders: 0,
      newInstance: true,
      settingsLoading: false,
      displayFieldSettings: null,
      returnSettingsService: null,
      allowReturnCreationInShop: [],
    };
  },
  created() {
    this.returnSettingsService = new ReturnSettingsService(this.$auth)
  },
  computed: {
    ...mapState(['roleRights', 'roles','currentStoreDetails', 'isOctipasAdmin', 'isCustomerService']),
    footerProps () {
      return {
        "items-per-page-options": [15, 30, 50],
        "items-per-page-text": this.$t("return.ordersPerPage")
      }
    },
    headerProps() {
      return {
        sortByText: this.$t("return.sortByText")
      }
    },
    headers(){
      let headers = [
        {
          text: this.$t("return.numOrder"),
          value: "order_id",
        },
        {
          text: this.$t("return.orderOrigin"),
          value: "origin",
          sortable: false
        },
        {
          text: this.$t("return.date"),
          value: "date",
        }
      ]

      if (this.addToHeaders(this.displayFieldSettings, 'customer_name', this.roles[0])) {
        headers.push(
          {
            text: this.$t('return.client'),
            value: 'customer',
            sortable: false
          })
      }

      headers.push({
          text: this.$t("return.status"),
          value: "current_status",
          sortable: false
        },
        {
          text: this.$t("return.quantity"),
          value: "quantity",
          sortable: false
        },
        {
          text: this.$t("return.amount"),
          value: "total_price",
          sortable: false
        },
        {
          text: this.$t('return.fromExternalService'),
          value: 'oms_order',
          sortable: true
        },
        {
          text: "",
          value: "action",
          sortable: false
        })

      return headers.filter((header) => !this.orderDetailsNotLoaded || header.value !== 'quantity')
    },
    statusTranslations() {
      return [
        { text: this.$t("return.waiting"), value: "waiting" },
        { text: this.$t('return.waitingPayment'), value:'waiting_payment' },
        { text: this.$t("return.confirmed"), value: "confirmed" },
        { text: this.$t("return.partiallyConfirmed"), value: "partially_confirmed" },
        { text: this.$t("return.toPickup"), value: "to_pickup" },
        { text: this.$t('return.waitingCarrier'), value:'waiting_carrier' },
        { text: this.$t("return.shippingInProgress"), value: "shipping_in_progress"},
        { text: this.$t("return.partialShippingInProgress"), value: "partial_shipping_in_progress"},
        { text: this.$t("return.delivered"), value: "delivered" },
        { text: this.$t("return.deliveredPartially"), value: "partially_delivered" },
        { text: this.$t("return.cancelled"), value: "cancelled" }
      ]
    },
    canCreateReturn() {
      // Check if user has any role that's in the allowReturnCreationInShop array
      if (!this.allowReturnCreationInShop || this.allowReturnCreationInShop.length === 0) {
        return false
      }
      // Check if any user role matches allowed roles
      return this.roles.some(role => this.allowReturnCreationInShop.includes(role))
    },
  },
  async mounted(){
    this.settingsLoading = true
    await this.getReturnSettings()
    if(!this.isCustomerService && !this.canCreateReturn){
      EventBus.$emit("displaySnackbar",{
        display: true,
          color: 'error',
          text: this.$t("views.unauthorized"),
      })
      await this.$router.push("/")
    }

    await this.getSettingsByCountry('FRA')
  },
  methods: {
    getNbProducts(item) {
        // get number of items
        let nbProduct = 0;

        if (item.items){
          for (let product of item.items) {
            nbProduct += product.product_quantity;
          }
        }

        return nbProduct;
    },
    list(values) {
      this.order = []
      this.loadingData = true;
      const { sortDesc, sortBy } = this.options;
      let myInit = {
        headers: {
          Authorization: "Bearer " + this.$auth.accessToken,
        },
        queryStringParameters: {
          itemsPerPage: '100',
          sortBy: sortBy.length === 0 ? "date" : sortBy,
          sortDesc: sortDesc.length === 0 ? true : sortDesc
        }
      }
      let filters = { order_id : values?.numOrder || undefined }
      if(values?.firstName || values?.lastName || values?.email) {
        filters.customer = {
          first_name: values.firstName || undefined,
          last_name: values.lastName || undefined,
          email: values.email || undefined
        }
      }
      if(values?.dateFrom || values?.dateTo) {
        filters.date = {
          from: values.dateFrom || undefined,
          to: values.dateTo || undefined,
        }
      }
      if(values?.phone?.number){
        filters.phone = values.phone.number
        filters.phone_prefix = values.phone.prefix
      }
      if (Object.entries(filters).length !== 0) {
        myInit.queryStringParameters.filters = JSON.stringify(filters);
      }
      myInit.queryStringParameters.status = ['delivered', 'partially_delivered'];
      this.$Amplify.API.get("returns", "/v1/int/transactions", myInit)
        .then((res) => {
          this.newInstance = false
          this.orders = res.data.map(transaction => transaction.order);
          this.totalOrders = res.nbTransactions
          this.orderDetailsNotLoaded = res.details_not_loaded
          this.loadingData = false;
        })
        .catch((e) => {
          this.orders = []
          this.loadingData = false;
          console.log(e);
          EventBus.$emit("displaySnackbar", {
            display: true,
            text: this.$t("return.ordersLoadingErrorMessage"),
            color: "error",
          });
        });
    },
    getStatusTranslation: function(statusValue) {
      let status = this.statusTranslations.find(status => status.value == statusValue);
      if (status) {
        return status.text;
      } else return statusValue;
    },
    createReturn(orderId){
      this.$router.push({ name: "returnCreate", params: {id: orderId} })
    },
    orderHasReturnableProducts(order){
      for(let item of order.items){
        if(item.is_returnable !== false){
          return true
        }
      }
      return false
    },
    allReturnableProductsAreFullyReturned(order){
      // Items not loaded (due to specific limitation) -> consider the order not fully returned
      if(order.details_not_loaded) {
        return false
      }

      for(let item of order.items){
        let notReturnableQuantity = item.returned_quantity || 0
        if(item.is_returnable === false){
          notReturnableQuantity = item.product_quantity
        }
        let validatedQuantity = item.validated_quantity || 0
        if( notReturnableQuantity < validatedQuantity){
          return false
        }
      }
      return true
    },
    async getReturnSettings() {
      try {
        const countryCode = this.currentStoreDetails.address.country_id
        const settings = await this.returnSettingsService.getReturnSettings(countryCode)
        this.allowReturnCreationInShop =
          settings && settings.allow_return_creation_in_shop ? settings.allow_return_creation_in_shop : ["oms-shop-manager"]
        this.settingsLoading = false
      } catch (e) {
        console.error(e)
        this.allowReturnCreationInShop = ["oms-shop-manager"]
        this.settingsLoading = false
      }
    },
    getSettingsByCountry(countryIso3){ // get the settings of the country selected
      this.settingsLoading = true
      let myInit = {
        headers: {
          "Authorization": 'Bearer ' + this.$auth.accessToken
        }
      }

      this.$Amplify.API.get("settings", "/v1/settings/" + countryIso3, myInit)
      .then((res) => {
        this.displayFieldSettings = res.display?.customer_information
        this.settingsLoading = false
      })
      .catch((e) => {
        this.settingsLoading = false
        console.log(e)
      })
    }
  }
};
</script>
